import React, { useEffect } from "react";
import Col from "react-bootstrap/lib/Col";
import { push } from "connected-react-router";
import { Field, Form, Formik } from "formik";
import moment from "moment";

import { actions as accountsActions, selectors as accountsSelectors } from "reducers/accounts";

import Container from "pages/_components/Container";
import Button from "pages/_components/Button";
import { DateRangeField } from "pages/_components/fields/DateRangeField";
import { bool, func, shape, string } from "prop-types";
import * as configUtils from "util/config";
import { connect } from "react-redux";
import { getLimitDate } from "util/date";
import { isMobile } from "react-device-detect";
import { isWeekend } from "date-fns";

const FORM_ID = "accounts.movements.filters.period";

const PeriodFilter = ({
    dispatch,
    isSubmitting,
    isDesktop,
    productId,
    setBalanceFalse,
    setBalanceTrue,
    parentSelectedFilter,
    handleClickHideFilters,
    filtersGlobal,
    searchByField,
    account,
}) => {
    const configDateTo = configUtils.getInteger("date.range.piker.days", -90);

    useEffect(() => {
        const submitButtonRef = document.getElementById("accountDetail-lastMovementsPeriodFilter-submitButton");
        if (submitButtonRef?.click) {
            // submitButtonRef.click()
        }
    }, []);

    const submitForm = async (event, allFormikProps) => {
        if (event) {
            event.preventDefault();
        }

        if (handleClickHideFilters) {
            handleClickHideFilters();
        }

        allFormikProps.submitForm();
    };

    const dateFrom =
        filtersGlobal.dateFrom ||
        getLimitDate(configDateTo) ||
        new Date(new Date().setDate(new Date().getDate() - configUtils.getArray("account.movement.defaultDays")));
    const dateTo = filtersGlobal.dateTo || moment().toDate() || new Date();

    const formikProps = {
        validateOnChange: true,
        validateOnBlur: false,
        initialValues: {
            dateFrom:
                filtersGlobal.dateFrom ||
                getLimitDate(configDateTo) ||
                new Date(
                    new Date().setDate(new Date().getDate() - configUtils.getArray("account.movement.defaultDays")),
                ),
            dateTo: filtersGlobal.dateTo || moment().toDate() || new Date(),
            dateRange: [dateFrom, dateTo],
        },
        onSubmit: ({ ...filters }, formikBag) => {
            if (parentSelectedFilter === "lastMonth") {
                setBalanceTrue();
            } else {
                setBalanceFalse();
            }
            if (isDesktop) {
                dispatch(
                    accountsActions.setFilterMovements({
                        parentFilter: parentSelectedFilter,
                        dateFrom: filters?.dateRange[0],
                        dateTo: filters?.dateRange[1],
                    }),
                );
                if (parentSelectedFilter === "lastMonth") {
                    dispatch(
                        accountsActions.details(productId, {
                            parentFilter: parentSelectedFilter,
                            dateFrom: filters?.dateRange[0],
                            dateTo: filters?.dateRange[1],
                        }),
                        formikBag,
                    );
                } else if (parentSelectedFilter === "pending") {
                    dispatch(
                        accountsActions.details(productId, {
                            parentFilter: parentSelectedFilter,
                            dateFrom: filters?.dateRange[0],
                            dateTo: filters?.dateRange[1],
                            cbu: account?.uniformBankCode,
                        }),
                        formikBag,
                    );
                }
            } else {
                dispatch(
                    accountsActions.setMobileFilter({
                        filter: "period",
                        dateFrom: filters?.dateRange[0],
                        dateTo: filters?.dateRange[1],
                    }),
                );
                dispatch(push(`/accounts/${productId}/filters/results`));
            }
        },
    };
    const handleReset = (allFormikProps) => {
        allFormikProps.setFieldValue("dateRange", [null, null]);
    };

    const filterDate = (date) => !isWeekend(date);

    return (
        <Formik {...formikProps}>
            {(allFormikProps) => (
                <Form id={FORM_ID} onSubmit={(e) => submitForm(e, allFormikProps)}>
                    {isMobile ? (
                        <Container className="height-80">
                            <div>
                                {!!searchByField && (
                                    <Col sm={12} md={6} className="pl-0">
                                        {searchByField()}
                                    </Col>
                                )}
                                <Col sm={12} md={searchByField ? 6 : null}>
                                    <Field
                                        component={DateRangeField}
                                        hidePlaceholder
                                        idForm={FORM_ID}
                                        minDate={getLimitDate(-184)}
                                        maxDate={getLimitDate(0)}
                                        name="dateRange"
                                        dateFormat="dd/MM/yyyy"
                                        selectsRange
                                        showMonthYearDropdown
                                        scrollableMonthYearDropdown
                                        noEdit
                                        selectsDisabledDaysInRange
                                        filterDate={filterDate}
                                    />
                                </Col>
                            </div>
                            {searchByField ? (
                                <div className="d-flex flex-column justify-content-end">
                                    <Col sm={12} md={6}>
                                        <Button
                                            id="accountDetail-lastMovementsPeriodFilter-submitButton"
                                            bsStyle="primary"
                                            label="product.filters.filter"
                                            loading={isSubmitting}
                                            type="submit"
                                            block
                                            className={isMobile && "mb-4"}
                                        />
                                    </Col>
                                    <Col sm={12} md={6} className="mt-5">
                                        <Button
                                            className="btn-outline"
                                            label="echecks.clean.filters"
                                            onClick={() => handleReset(allFormikProps)}
                                        />
                                    </Col>
                                </div>
                            ) : (
                                <div className="d-flex flex-column justify-content-end">
                                    <Col sm={12} className="md:grid-cols-2">
                                        <Button
                                            id="accountDetail-lastMovementsPeriodFilter-submitButton"
                                            bsStyle="primary"
                                            label="product.filters.filter"
                                            loading={isSubmitting}
                                            type="submit"
                                            block
                                            className={isMobile && "mb-4"}
                                        />
                                        <Button
                                            className="btn-outline"
                                            label="echecks.clean.filters"
                                            onClick={() => handleReset(allFormikProps)}
                                        />
                                    </Col>
                                </div>
                            )}
                        </Container>
                    ) : (
                        <Container className="container--layout items-center" gridClassName="form-content">
                            {!!searchByField && (
                                <Col sm={12} md={6} className="pl-0">
                                    {searchByField()}
                                </Col>
                            )}
                            <Col sm={12} md={searchByField ? 6 : null}>
                                <Field
                                    component={DateRangeField}
                                    hidePlaceholder
                                    idForm={FORM_ID}
                                    minDate={getLimitDate(-184)}
                                    maxDate={getLimitDate(0)}
                                    name="dateRange"
                                    dateFormat="dd/MM/yyyy"
                                    selectsRange
                                    showMonthYearDropdown
                                    scrollableMonthYearDropdown
                                    noEdit
                                    selectsDisabledDaysInRange
                                    filterDate={filterDate}
                                />
                            </Col>
                            {searchByField ? (
                                <>
                                    <Col sm={12} md={6}>
                                        <Button
                                            className="btn-outline"
                                            label="echecks.clean.filters"
                                            onClick={() => handleReset(allFormikProps)}
                                        />
                                    </Col>
                                    <Col sm={12} md={6}>
                                        <Button
                                            id="accountDetail-lastMovementsPeriodFilter-submitButton"
                                            bsStyle="primary"
                                            label="product.filters.filter"
                                            loading={isSubmitting}
                                            type="submit"
                                            block
                                        />
                                    </Col>
                                </>
                            ) : (
                                <Col sm={12} className="md:grid-cols-2">
                                    <Button
                                        className="btn-outline"
                                        label="echecks.clean.filters"
                                        onClick={() => handleReset(allFormikProps)}
                                    />
                                    <Button
                                        id="accountDetail-lastMovementsPeriodFilter-submitButton"
                                        bsStyle="primary"
                                        label="product.filters.filter"
                                        loading={isSubmitting}
                                        type="submit"
                                        block
                                    />
                                </Col>
                            )}
                        </Container>
                    )}
                </Form>
            )}
        </Formik>
    );
};

PeriodFilter.propTypes = {
    isSubmitting: bool,
    values: shape([]),
    isDesktop: bool.isRequired,
    dispatch: func.isRequired,
    productId: string.isRequired,
    parentSelectedFilter: string.isRequired,
    setBalanceFalse: func,
    setBalanceTrue: func,
    filtersGlobal: shape({}).isRequired,
    account: shape({}).isRequired,
    handleClickHideFilters: func,
    searchByField: func,
};

PeriodFilter.defaultProps = {
    isSubmitting: false,
    values: [],
    setBalanceFalse: null,
    setBalanceTrue: null,
    handleClickHideFilters: null,
    searchByField: null,
};

const mapStateToProps = (state) => ({
    filtersGlobal: accountsSelectors.getFilters(state),
    account: accountsSelectors.getSelectedAccount(state),
});

export default connect(mapStateToProps)(PeriodFilter);
